import { Component } from '@angular/core';

@Component({
  selector: 'rid-key-group',
  templateUrl: './rid-key-group.html',
  styleUrl: './rid-key-group.css',
})
export class RidKeyGroup {}
